export type Accent = 'primary' | 'secondary' | 'orange';

// Full literal class strings per accent — Tailwind only generates classes it can
// see verbatim, so never build these by interpolation at the call site.
export const accentIcon: Record<Accent, string> = {
  primary: 'bg-primary/10 text-primary',
  secondary: 'bg-secondary/10 text-secondary',
  orange: 'bg-brand-orange/10 text-brand-orange',
};

export const accentBorderHover: Record<Accent, string> = {
  primary: 'hover:border-primary',
  secondary: 'hover:border-secondary',
  orange: 'hover:border-brand-orange',
};

export const accentText: Record<Accent, string> = {
  primary: 'text-primary',
  secondary: 'text-secondary',
  orange: 'text-brand-orange',
};

// Cycle accents across a grid so sibling cards alternate colour.
export const accentByIndex = (index: number): Accent =>
  (['primary', 'secondary', 'orange'] as const)[index % 3];
